/**
 * Positive allowlists of People.type_of_position values, deciding who shows
 * up on the page from Topic.related_researchers, Project.related_members and
 * Project.related_assistants.
 *
 * Deliberately an allowlist rather than an exclusion such as "hide Alumni":
 * a newly added position type stays hidden until it is listed here. It is
 * what keeps people marked "Inaktive" (hrl-site) off a project's page while
 * the relation itself stays. Values
 * are the type_of_position tokens or titles from the Academic Types control
 * panel.
 */

export const RESEARCHER_POSITIONS = [
  'Group Leader',
  'Ph.D. Student',
  'Postdoc',
  'Scientific Staff',
  'Associated Researcher',
  'Visiting Researcher',
  'Alumni-active',
  'Alumni',
];

export const STUDENT_ASSISTANT_POSITIONS = ['Student Assistant'];

const positionKey = (item) => {
  const pos = item?.type_of_position;
  if (!pos) return null;
  if (typeof pos === 'string') return pos;
  return pos.title || pos.token || null;
};

/**
 * Filter a list of related People items down to the ones whose
 * type_of_position is in allowedPositions. Items without a
 * type_of_position (e.g. not a People item, or field not set) are dropped.
 */
export const filterByPosition = (items, allowedPositions) =>
  (items || []).filter((item) => {
    const key = positionKey(item);
    return key != null && allowedPositions.includes(key);
  });
